(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-brands"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('featured-brands')) {
  class FeaturedBrands extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.track = this.querySelector('.featured-brands__track');
      this.section = this.closest('.featured-brands');
      if (!this.track || !this.section) return;

      this.prevBtn = this.section.querySelector('.featured-brands__prev');
      this.nextBtn = this.section.querySelector('.featured-brands__next');
      this.totalPages = parseInt(this.dataset.totalPages, 10) || 1;
      this.currentPage = 0;

      this.applyTransform();

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));

      window.addEventListener('resize', this.debouncedResize());
    }

    debouncedResize() {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(() => this.applyTransform(), 150);
      };
    }

    go(delta) {
      const next = this.currentPage + delta;
      if (next < 0 || next > this.totalPages - 1) return;
      this.currentPage = next;
      this.applyTransform();
    }

    applyTransform() {
      const viewportWidth = this.getBoundingClientRect().width;
      const offset = -this.currentPage * viewportWidth;
      this.track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';

      if (this.prevBtn) this.prevBtn.disabled = this.currentPage <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentPage >= this.totalPages - 1;
    }
  }

  customElements.define('featured-brands', FeaturedBrands);
}

if (!window.__priceListDownloadHandlerInstalled) {
  window.__priceListDownloadHandlerInstalled = true;
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-price-list-link]');
    if (!link) return;
    var url = link.getAttribute('href');
    if (!url) return;
    e.preventDefault();

    var filenameFromUrl = (url.split('/').pop() || 'price-list').split('?')[0];
    var filename = (link.dataset.brandHandle ? link.dataset.brandHandle + '-' : '') + filenameFromUrl;

    fetch(url, { mode: 'cors', credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('fetch failed: ' + res.status);
        return res.blob();
      })
      .then(function (blob) {
        var objectUrl = URL.createObjectURL(blob);
        var tmp = document.createElement('a');
        tmp.href = objectUrl;
        tmp.download = filename;
        document.body.appendChild(tmp);
        tmp.click();
        document.body.removeChild(tmp);
        setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 1000);
      })
      .catch(function () {
        window.open(url, '_blank', 'noopener');
      });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-brands"]) return;
  try {
    
  if (!customElements.get('brands-list')) {
    class BrandsList extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.input = this.querySelector('.brands-search__input');
        this.cards = Array.from(this.querySelectorAll('.brands-card'));
        this.noResults = this.querySelector('.brands-page__no-results');
        this.countEl = this.querySelector('.brands-count');
        this.total = parseInt(this.dataset.total, 10) || this.cards.length;

        if (!this.input) return;

        this.input.addEventListener('input', () => this.filter());

        const url = new URL(window.location.href);
        const q = url.searchParams.get('q');
        if (q) {
          this.input.value = q;
          this.filter();
        }
      }

      filter() {
        const q = (this.input.value || '').trim().toLowerCase();
        let visible = 0;

        this.cards.forEach((card) => {
          const text = card.dataset.searchText || '';
          const match = !q || text.indexOf(q) !== -1;
          card.hidden = !match;
          if (match) visible++;
        });

        if (this.noResults) {
          this.noResults.hidden = visible !== 0;
        }
        if (this.countEl) {
          this.countEl.textContent = q ? visible : this.total;
        }
      }
    }

    customElements.define('brands-list', BrandsList);
  }

  if (!window.__priceListDownloadHandlerInstalled) {
    window.__priceListDownloadHandlerInstalled = true;
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-price-list-link]');
      if (!link) return;
      var url = link.getAttribute('href');
      if (!url) return;
      e.preventDefault();

      var filenameFromUrl = (url.split('/').pop() || 'price-list').split('?')[0];
      var filename = (link.dataset.brandHandle ? link.dataset.brandHandle + '-' : '') + filenameFromUrl;

      fetch(url, { mode: 'cors', credentials: 'omit' })
        .then(function (res) {
          if (!res.ok) throw new Error('fetch failed: ' + res.status);
          return res.blob();
        })
        .then(function (blob) {
          var objectUrl = URL.createObjectURL(blob);
          var tmp = document.createElement('a');
          tmp.href = objectUrl;
          tmp.download = filename;
          document.body.appendChild(tmp);
          tmp.click();
          document.body.removeChild(tmp);
          setTimeout(function () {
            URL.revokeObjectURL(objectUrl);
          }, 1000);
        })
        .catch(function () {
          window.open(url, '_blank', 'noopener');
        });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
